<template>
  <v-container style="margin-top: 40px;" class="align-center justify-center text-center">
    <v-row class="align-center justify-center text-center">
      <v-col cols="12" :sm="8" :md="6" >
        <v-card>
          <v-card-text class="success">
            <span>
              <v-icon>mdi-checkbox-marked-circle</v-icon>
              &nbsp;{{message}}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="$store.state.isLoggedIn">
      <v-col>
        <v-btn to="/dashboard" class="primary">
          <v-icon left>mdi-view-dashboard</v-icon>{{$t('home.goto-dashboard')}}
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-btn to="/login" class="primary">
          <v-icon left>mdi-login</v-icon>{{$t('common.login')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { MUTATION_DISMISS_NOTIFICATION } from "@/plugins/store.js";

export default {
  name: "SuccessView",
  components: {
  },
  props: {
    message: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
    };
  },
  mounted: function() {
  },
  destroyed: function () {
    this.$store.commit(MUTATION_DISMISS_NOTIFICATION);
  },
  methods: {}
};
</script>
